import React, { Component } from "react";
import { Row, Col, Media } from "reactstrap";
import viewHeaderImage from "./images/viewHeader.png";
import viewHeaderImageMobile from "./images/viewHeaderMobile.png";
import { joinCss } from "./helpers/utils";

import appClasses from "./App.module.scss";
import classes from "./HeaderImage.module.scss";

class headerImage extends Component {
  constructor() {
    super();
    this.state = {
      mdSize: false
    };
  }

  updateDimensions() {
    if (window.innerWidth <= 992 || window.screen.width <= 992) {
      this.setState({ mdSize: true });
    } else {
      this.setState({ mdSize: false });
    }
  }

  /**
   * Add event listener
   */
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    let buttonSection = null;
    if (this.props.button) {
      const TagName = this.props.button;
      buttonSection = <TagName />;
    }
    var toReturn = (
      <Row>
        <Col sm="12" className="px-0">
          <Media heading>
            <Media
              src={this.state.mdSize ? viewHeaderImageMobile : viewHeaderImage}
              alt="תמונה כללית"
              className={appClasses.headerImage}
            />
          </Media>
          <div className={joinCss(classes.headerTitle, "mt-2 mr-5")}>
            <div>{this.props.viewName.firstLine}</div>
            <div>{this.props.viewName.secondLine}</div>
          </div>
          {buttonSection}
        </Col>
      </Row>
    );
    return toReturn;
  }
}

export default headerImage;
